module.exports = __webpack_public_path__ + "img/img_plan.80ae30c5.jpg";